var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegrationsDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16175_105801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5V40.5H40V0.5H0ZM1.70833 38.7917V10.3778C3.77405 9.84436 5.95764 10.0024 7.925 10.8278L5.49444 11.1333L7.38889 12.6056L11.3556 12.1056L10.8556 8.14167L8.96111 6.66944L9.33611 9.65C6.99019 8.42912 4.28677 8.08159 1.70833 8.66945V2.20833H5.27778C8.86389 4.24167 13.0778 7.05 15.4806 11.1694L13.1056 10.1167L13.9667 12.3556L17.6194 13.975L19.2417 10.3222L18.3806 8.08333L17.1833 10.7778C15.1444 7.01944 11.7806 4.28611 8.51944 2.20833H19.1667V4.72778L17.175 2.73611V5.13611L20 7.96111L22.825 5.13611V2.73611L20.8333 4.72778V2.20833H31.5444C28.4889 4.21111 25.125 6.98611 23.0806 10.7806L21.8806 8.08611L21.0222 10.325L22.6472 13.975L26.2972 12.35L27.1556 10.1083L24.7694 11.1722C27.2222 6.95 31.4944 4.08056 34.7222 2.20833H38.2889V8.66945C35.7104 8.0838 33.0077 8.43123 30.6611 9.65L31.0389 6.66944L29.1444 8.14167L28.6444 12.1056L32.6083 12.6056L34.5028 11.1333L32.0722 10.8278C34.0397 10.0028 36.2231 9.84478 38.2889 10.3778V38.7917H1.70833Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5363 31.9861H16.8696V33.825H18.5363V31.9861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5915 31.9861H21.9248V33.825H23.5915V31.9861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6777 27.9333H20.8332V26.0083H19.1666V27.9333H16.7832C15.9544 27.934 15.1595 28.2629 14.5724 28.8479C13.9852 29.433 13.6536 30.2267 13.6499 31.0555V36.9444H26.811V31.0555C26.8073 30.2267 26.4757 29.433 25.8886 28.8479C25.3014 28.2629 24.5065 27.934 23.6777 27.9333ZM25.1443 35.2889H15.3166V31.0555C15.3173 30.6668 15.4721 30.2941 15.747 30.0192C16.0219 29.7443 16.3945 29.5896 16.7832 29.5889H23.6777C24.0664 29.5896 24.4391 29.7443 24.714 30.0192C24.9889 30.2941 25.1436 30.6668 25.1443 31.0555V35.2889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5585 21.8694V25.461H22.4446V22.061L28.9669 15.2888H10.5752L17.5585 21.8694ZM20.778 23.7944H19.2252V22.3305H20.778V23.7944ZM21.4752 20.6638H18.6974L14.7724 16.9555H25.0502L21.4752 20.6638Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16175_105801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsDashboard);
export default __webpack_public_path__ + "static/media/integrations-dashboard.5e625cd9ce5021c8027944982f35e4b0.svg";
export { ForwardRef as ReactComponent };